import { dynamicLoader } from '~/utils';

export const CompanyEditor = dynamicLoader({
  name: 'CompanyEditorWrapper',
  importFunc: () => import('./company-editor-wrapper'),
});

//export const CompanyQuickEditForm = dynamicLoader({
//  name: 'CompanyQuickEditForm',
//  importFunc: () => import('./company-quick-edit-form'),
//});

//export const CompanyEditForm = dynamicLoader({
//  name: 'CompanyEditForm',
//  importFunc: () => import('./company-edit-form'),
//});